'use client';

import { c as _c } from "react/compiler-runtime";
import { Checkbox as CheckboxPrimitive } from '@base-ui/react/checkbox';
import { cn } from '@repo/ui/lib/utils';
import { CheckIcon, MinusIcon } from 'lucide-react';
function Checkbox(t0) {
  const $ = _c(15);
  let checked;
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      checked,
      className,
      indeterminate: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = checked;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
  } else {
    checked = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
  }
  const indeterminate = t1 === undefined ? false : t1;
  const t2 = typeof checked === "undefined" ? false : checked;
  let t3;
  if ($[5] !== className) {
    t3 = cn("peer relative flex size-4 shrink-0 items-center justify-center rounded-sm border border-input transition-colors outline-none group-has-disabled/field:opacity-50 after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-primary data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground data-disabled:cursor-not-allowed data-disabled:opacity-50 data-indeterminate:border-primary/50 data-indeterminate:bg-primary/50 data-indeterminate:text-primary-foreground dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 dark:data-checked:bg-primary", className);
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== indeterminate) {
    t4 = <CheckboxPrimitive.Indicator className="grid place-content-center text-current transition-none [&>svg]:size-3.5" data-slot="checkbox-indicator" data-sentry-element="CheckboxPrimitive.Indicator" data-sentry-source-file="checkbox.tsx">{indeterminate ? <MinusIcon className="text-current" /> : <CheckIcon className="text-current" />}</CheckboxPrimitive.Indicator>;
    $[7] = indeterminate;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== indeterminate || $[10] !== props || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <CheckboxPrimitive.Root checked={t2} className={t3} data-slot="checkbox" indeterminate={indeterminate} {...props} data-sentry-element="CheckboxPrimitive.Root" data-sentry-component="Checkbox" data-sentry-source-file="checkbox.tsx">{t4}</CheckboxPrimitive.Root>;
    $[9] = indeterminate;
    $[10] = props;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
export { Checkbox };